import React, { useRef, useEffect, useState } from 'react';
import { FormControl } from 'react-bootstrap';
import PropTypes from 'prop-types';

let isComposition = false;
const isChrome = navigator.userAgent.indexOf('Chrome') > -1;

/**
 * Used in FilterItem component for default text input.
 * DateFilterItem, DynamicSelect, Input components are used in FilterItem.
 *
 * @param {*} param
 * @returns
 */

const Input = ({ type, placeholder, onChange, value }) => {
  const inputEl = useRef(null);
  const [lastChangedTimestamp, setLastChangedTimestamp] = useState(0);

  const handleComposition = e => {
    if (e.type === 'compositionend') {
      isComposition = false;
      if (isChrome) {
        handleChange(e);
      }
    } else {
      isComposition = true;
    }
  };
  const handleChange = e => {
    if (!isComposition) {
      setLastChangedTimestamp(Date.now());
      onChange(e);
    }
  };

  //Init value
  useEffect(() => {
    inputEl.current.value = value;
  }, []);

  //Set value to out value
  useEffect(() => {
    const now = Date.now();
    if (now - lastChangedTimestamp > 1000) {
      inputEl.current.value = value;
    }
  }, [value]);

  return (
    <FormControl
      ref={inputEl}
      type={type}
      placeholder={placeholder}
      onCompositionStart={handleComposition}
      onCompositionEnd={handleComposition}
      onChange={handleChange}
    />
  );
};

Input.propTypes = {
  type: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func
};

export default Input;
